module.exports = __webpack_public_path__ + "static/assets/1f08a68d26e11821bb56f26c881ac1c3.png";